import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { MatTableDataSource } from '@angular/material/table';
import { MatSnackBar } from "@angular/material/snack-bar";
import { CompanyService } from "src/app/shared/services/company.service";
import { MatDialog } from "@angular/material/dialog";
import { Subject, takeUntil } from "rxjs";
import { DeleteCompanyComponent } from "src/app/shared/components/delete-company/delete-company.component";

@Component({
    selector: 'app-company-management',
    templateUrl: './company-management.component.html',
    styleUrls: ['./company-management.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyManagementComponent implements OnInit {
  private readonly destroyed$ = new Subject<boolean>();
  dataSource = new MatTableDataSource<any>();
  displayedColumns: string[] = [
    'companyNumber',
    'name',
    'actions'
  ];

  constructor(
    private router: Router,
    public snackBar: MatSnackBar,
    public companyService: CompanyService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.loadCompaniesTable();
  }

  reDirectUrl() {
    this.router.navigate(['dashboard']);
  }

  loadCompaniesTable() {
    this.companyService.getAllCompanies().subscribe({
      next: (companies) => {
        const companyArray = Array.isArray(companies) ? companies : [companies];
        this.dataSource.data = companyArray.sort((a, b) => a.name.localeCompare(b.name));
      }
    });
  }

  deleteCompany(company: any): void {
    this.dialog
      .open(DeleteCompanyComponent, {
        data: {
          deletedCompany: company,
          allCompanies: this.dataSource.data,
        },
        disableClose: true,
        width: '40%',
      })
      .afterClosed()
      .pipe(takeUntil(this.destroyed$))
      .subscribe((deleted) => {
        if (deleted) {
          this.loadCompaniesTable();
        }
      });
  }
}
